<template>
  <div class="personal-center">
    <a-card class="header-card" :bordered="false">
      <div class="user-meta">
        <a-avatar :src="avatarUrl" size="large" icon="user" />
        <div class="user-text">
          <div class="name">{{ realname || username || "未登录" }}</div>
          <div class="desc">管理我发布的成果和需求，查看审核进度</div>
        </div>
      </div>
    </a-card>

    <a-card class="content-card" :bordered="false">
      <a-tabs v-model="activeTab" @change="handleTabChange">
        <a-tab-pane key="eventSignup" tab="我的报名">
          <a-table
            rowKey="id"
            :loading="eventSignupLoading"
            :data-source="eventSignupList"
            :columns="eventSignupColumns"
            :pagination="eventSignupPagination"
            @change="handleEventSignupChange"
          >
            <template slot="eventName" slot-scope="text, record">
              <a @click="goEventDetail(record)">{{ text }}</a>
            </template>
            <template slot="auditStatus" slot-scope="text, record">
              <a-tag :color="eventSignupStatusColor(record.auditStatus)">
                {{ record.auditStatus_dictText || eventSignupStatusText(record.auditStatus) }}
              </a-tag>
            </template>
            <template slot="eventSignupAction" slot-scope="text, record">
              <a-space>
                <a @click="goEventDetail(record)">查看活动</a>
                <a-divider type="vertical" />
                <a :class="{ disabled: !canEditEventSignup(record) }" @click="editEventSignup(record)">修改报名</a>
                <a-divider type="vertical" />
                <a :class="{ disabled: !canDownloadApplication(record) }" @click="downloadApplicationWord(record)">下载申请表</a>
                <a-divider type="vertical" />
                <a :class="{ disabled: !canUploadApplication(record) }" @click="openApplicationUpload(record)">上传申请表</a>
              </a-space>
            </template>
          </a-table>
          <a-modal
            :visible="applicationUploadVisible"
            title="上传申请表照片"
            :confirmLoading="applicationUploading"
            @ok="saveApplicationImages"
            @cancel="closeApplicationUpload"
          >
            <j-upload
              v-model="applicationImages"
              fileType="image"
              bizPath="eventApplicationImage"
              text="上传照片"
            />
          </a-modal>
        </a-tab-pane>
        <a-tab-pane key="achievement" tab="我的成果">
          <a-table
            rowKey="id"
            :loading="achievementLoading"
            :data-source="achievementList"
            :columns="achievementColumns"
            :pagination="achievementPagination"
            @change="handleAchievementChange"
          >
            <template slot="name" slot-scope="text, record">
              <a @click="goAchievementDetail(record)">{{ text }}</a>
            </template>
            <template slot="reviewStatus" slot-scope="text, record">
              <a-tag :color="statusColor(record.reviewStatus)">
                {{ reviewStatusText(record) }}
              </a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-space>
                <a @click="editAchievement(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="openCooperationModal(record)">请求合作</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="确认删除该成果？"
                  ok-text="删除"
                  cancel-text="取消"
                  @confirm="removeAchievement(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-space>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="demand" tab="我的需求">
          <a-table
            rowKey="id"
            :loading="demandLoading"
            :data-source="demandList"
            :columns="demandColumns"
            :pagination="demandPagination"
            @change="handleDemandChange"
          >
            <template slot="name" slot-scope="text, record">
              <a @click="goDemandDetail(record)">{{ text }}</a>
            </template>
            <template slot="reviewStatus" slot-scope="text, record">
              <a-tag :color="statusColor(record.reviewStatus)">
                {{ reviewStatusText(record) }}
              </a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-space>
                <a @click="editDemand(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="openBidListModal(record)">揭榜列表</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="确认删除该需求？"
                  ok-text="删除"
                  cancel-text="取消"
                  @confirm="removeDemand(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-space>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="follow" tab="我的关注">
          <a-tabs v-model="followActiveType" @change="handleFollowTypeChange" style="margin-bottom: 16px">
            <a-tab-pane key="achievement" tab="成果">
              <a-table
                rowKey="id"
                :loading="followAchievementLoading"
                :data-source="followAchievementList"
                :columns="followAchievementColumns"
                :pagination="followAchievementPagination"
                @change="handleFollowAchievementChange"
              >
                <template slot="name" slot-scope="text, record">
                  <a @click="goAchievementDetail(record)">{{ text }}</a>
                </template>
                <template slot="pcaSlot" slot-scope="text">
                  {{ getAreaText(text) }}
                </template>
                <template slot="followAction" slot-scope="text, record">
                  <a-popconfirm title="确定取消关注?" @confirm="cancelFollow(record.id)">
                    <a>取消关注</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="expert" tab="专家">
              <a-table
                rowKey="id"
                :loading="followExpertLoading"
                :data-source="followExpertList"
                :columns="followExpertColumns"
                :pagination="followExpertPagination"
                @change="handleFollowExpertChange"
              >
                <template slot="name" slot-scope="text, record">
                  <a>{{ text }}</a>
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
        <a-tab-pane key="cooperation" tab="我的合作">
          <a-table
            rowKey="id"
            :loading="cooperationLoading"
            :data-source="cooperationList"
            :columns="cooperationColumns"
            :pagination="cooperationPagination"
            @change="handleCooperationChange"
          >
            <template slot="name" slot-scope="text, record">
              <a @click="goAchievementDetail(record)">{{ text }}</a>
            </template>
            <template slot="pcaSlot" slot-scope="text">
              {{ getAreaText(text) }}
            </template>
            <template slot="cooperationAction" slot-scope="text, record">
              <a-popconfirm title="确定删除该合作?" @confirm="deleteCooperation(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="bid" tab="我的揭榜">
          <a-table
            rowKey="id"
            :loading="bidLoading"
            :data-source="bidList"
            :columns="bidColumns"
            :pagination="bidPagination"
            @change="handleBidChange"
          >
            <template slot="name" slot-scope="text, record">
              <a @click="goDemandDetail(record)">{{ text }}</a>
            </template>
            <template slot="pcaSlot" slot-scope="text">
              {{ getAreaText(text) }}
            </template>
            <template slot="bidAction" slot-scope="text, record">
              <a-popconfirm title="确定删除该揭榜?" @confirm="deleteBid(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <!-- 合作请求列表模态框 -->
  <a-modal
    title="合作请求列表"
    :visible="cooperationModalVisible"
    :width="1400"
    @cancel="closeCooperationModal"
    :footer="null"
  >
    <a-table
      rowKey="id"
      :loading="cooperationListLoading"
      :data-source="cooperationRequestList"
      :columns="cooperationRequestColumns"
      :pagination="cooperationRequestPagination"
      @change="handleCooperationRequestChange"
    >
      <template slot="viewDetail" slot-scope="text, record">
        <a @click="openDetailModal(record)">查看详情</a>
      </template>
    </a-table>
  </a-modal>

  <!-- 合作请求详情模态框 -->
  <a-modal
    title="合作请求详情"
    :visible="detailModalVisible"
    :width="800"
    @cancel="closeDetailModal"
    :footer="null"
  >
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="姓名">{{ currentDetailData ? currentDetailData.name : '' }}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{ currentDetailData ? currentDetailData.phone : '' }}</a-descriptions-item>
      <a-descriptions-item label="邮箱">{{ currentDetailData ? currentDetailData.email : '' }}</a-descriptions-item>
      <a-descriptions-item label="所在地区">{{ currentDetailData && currentDetailData.areaId ? getAreaText(currentDetailData.areaId) : '' }}</a-descriptions-item>
      <a-descriptions-item label="预约时间">{{ currentDetailData ? currentDetailData.appointmentTime : '' }}</a-descriptions-item>
      <a-descriptions-item label="预约事项说明">{{ currentDetailData ? currentDetailData.appointmentRemark : '' }}</a-descriptions-item>
    </a-descriptions>
  </a-modal>

  <!-- 揭榜列表模态框 -->
  <a-modal
    title="揭榜列表"
    :visible="bidListModalVisible"
    :width="1400"
    @cancel="closeBidListModal"
    :footer="null"
  >
    <a-table
      rowKey="id"
      :loading="bidListLoading"
      :data-source="bidListData"
      :columns="bidListColumns"
      :pagination="bidListPagination"
      @change="handleBidListChange"
    >
      <template slot="viewBidDetail" slot-scope="text, record">
        <a @click="openBidDetailModal(record)">查看详情</a>
      </template>
    </a-table>
  </a-modal>

  <!-- 揭榜详情模态框 -->
  <a-modal
    title="揭榜详情"
    :visible="bidDetailModalVisible"
    :width="800"
    @cancel="closeBidDetailModal"
    :footer="null"
  >
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="姓名">{{ currentBidDetailData ? currentBidDetailData.name : '' }}</a-descriptions-item>
      <a-descriptions-item label="手机号码">{{ currentBidDetailData ? currentBidDetailData.phone : '' }}</a-descriptions-item>
      <a-descriptions-item label="所在单位">{{ currentBidDetailData ? currentBidDetailData.unit : '' }}</a-descriptions-item>
      <a-descriptions-item label="揭榜时间">{{ currentBidDetailData ? currentBidDetailData.createTime : '' }}</a-descriptions-item>
      <a-descriptions-item label="研究领域">{{ currentBidDetailData ? currentBidDetailData.technicalField_dictText : '' }}</a-descriptions-item>
      <a-descriptions-item label="方案简述">{{ currentBidDetailData ? currentBidDetailData.description : '' }}</a-descriptions-item>
      <a-descriptions-item label="附件">
        <template v-if="currentBidDetailData && currentBidDetailData.fileUrl">
          <a :href="currentBidDetailData.fileUrl" target="_blank">
            查看附件
          </a>
        </template>
        <template v-else>
          无
        </template>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>

  </div>
</template>

<script>
import { getAction, deleteAction, httpAction, downloadFile } from "@/api/manage";
import Area from '@/components/_util/Area'
import JUpload from '@/components/jeecg/JUpload'

export default {
  name: "PersonalCenter",
  components: { JUpload },
  data() {
    return {
      activeTab: "eventSignup",
      achievementLoading: false,
      demandLoading: false,
      eventSignupLoading: false,
      applicationUploadVisible: false,
      applicationUploading: false,
      applicationSignup: null,
      applicationImages: "",
      achievementList: [],
      demandList: [],
      eventSignupList: [],
      pcaData: null,
      achievementPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      demandPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      eventSignupPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      achievementColumns: [
        { title: "成果名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "审核状态", dataIndex: "reviewStatus", scopedSlots: { customRender: "reviewStatus" }, width: 120 },
        { title: "创建时间", dataIndex: "createTime", width: 180 },
        { title: "操作", key: "action", scopedSlots: { customRender: "action" }, width: 250 }
      ],
      demandColumns: [
        { title: "需求名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "审核状态", dataIndex: "reviewStatus", scopedSlots: { customRender: "reviewStatus" }, width: 120 },
        { title: "创建时间", dataIndex: "createTime", width: 180 },
        { title: "操作", key: "action", scopedSlots: { customRender: "action" }, width: 250 }
      ],
      eventSignupColumns: [
        { title: "活动名", dataIndex: "eventName", scopedSlots: { customRender: "eventName" } },
        { title: "活动项目", dataIndex: "projectCode_dictText", width: 140 },
        { title: "审核状态", dataIndex: "auditStatus", scopedSlots: { customRender: "auditStatus" }, width: 120 },
        { title: "报名时间", dataIndex: "submitTime", width: 180 },
        { title: "审核批注", dataIndex: "auditComment", width: 220 },
        { title: "操作", key: "action", scopedSlots: { customRender: "eventSignupAction" }, width: 360 }
      ],
      // 关注相关配置
      followActiveType: "achievement",
      followAchievementLoading: false,
      followExpertLoading: false,
      followAchievementList: [],
      followExpertList: [],
      followAchievementPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      followExpertPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      followAchievementColumns: [
        { title: "成果名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "技术成熟度", dataIndex: "technicalMaturity" },
        { title: "技术领域", dataIndex: "technicalField_dictText" },
        //所在地区通过getAreaText方法获取
        { title: "所在地区", dataIndex: "areaId", scopedSlots: { customRender: "pcaSlot" } },
        { title: "关注时间", dataIndex: "createTime", width: 180 },
        { title: "操作", key: "action", scopedSlots: { customRender: "followAction" }, width: 180 }
      ],
      followExpertColumns: [
        { title: "专家名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "单位", dataIndex: "unit" },
        { title: "所属领域", dataIndex: "field" },
        { title: "关注时间", dataIndex: "followTime", width: 180 }
      ],
      // 合作列表相关配置
      cooperationLoading: false,
      cooperationList: [],
      cooperationPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      cooperationColumns: [
        { title: "成果名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "技术成熟度", dataIndex: "technicalMaturity" },
        { title: "技术领域", dataIndex: "technicalField_dictText" },
        //所在地区通过getAreaText方法获取
        { title: "所在地区", dataIndex: "areaId", scopedSlots: { customRender: "pcaSlot" } },
        { title: "提交时间", dataIndex: "createTime", width: 180 },
        { title: "操作", key: "action", scopedSlots: { customRender: "cooperationAction" }, width: 180 }
      ],
      // 揭榜列表相关配置
      bidLoading: false,
      bidList: [],
      bidPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      bidColumns: [
        { title: "需求名称", dataIndex: "name", scopedSlots: { customRender: "name" } },
        { title: "公司名称", dataIndex: "companyName" },
        { title: "所属行业", dataIndex: "industryField_dictText" },
        //所在地区通过getAreaText方法获取
        { title: "需求地点", dataIndex: "areaId", scopedSlots: { customRender: "pcaSlot" } },
        { title: "揭榜时间", dataIndex: "createTime", width: 180 },
        { title: "操作", key: "action", scopedSlots: { customRender: "bidAction" }, width: 180 }
      ],
      // 合作请求相关配置
      cooperationModalVisible: false,
      currentTechId: null,
      cooperationRequestList: [],
      cooperationRequestPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      cooperationRequestColumns: [
        { title: "姓名", dataIndex: "name" ,width: 180},
        { title: "联系电话", dataIndex: "phone", width: 180 },
        { title: "所在地区", dataIndex: "areaId", customRender: (text) => this.getAreaText(text), width: 200 },
        { title: "提交时间", dataIndex: "createTime", width: 200 },
        { title: "操作", key: "action", width: 120, scopedSlots: { customRender: "viewDetail" } }
      ],
      // 详情弹窗相关配置
      detailModalVisible: false,
      currentDetailData: null,
      cooperationListLoading: false,
      // 揭榜列表相关配置
      bidListModalVisible: false,
      currentDemandId: null,
      bidListData: [],
      bidListPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      bidListColumns: [
        { title: "姓名", dataIndex: "name", width: 180 },
        { title: "手机号码", dataIndex: "phone", width: 180 },
        { title: "所在单位", dataIndex: "unit", width: 200 },
        { title: "揭榜时间", dataIndex: "createTime", width: 200 },
        { title: "操作", key: "action", width: 120, scopedSlots: { customRender: "viewBidDetail" } }
      ],
      bidListLoading: false,
      // 揭榜详情相关配置
      bidDetailModalVisible: false,
      currentBidDetailData: null,
      reviewStatusMap: {
        0: "待审核",
        1: "审核通过",
        2: "审核驳回"
      }
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.avatar) {
        return this.$store.state.user.avatar;
      } else if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar;
      }
      return "/img/avatar.png";
    },
    realname() {
      return this.$store.state.user.info.realname;
    },
    username() {
      return this.$store.state.user.info.username;
    }
  },
  created() {
    const tab = this.$route.query.tab;
    if (tab) {
      this.activeTab = tab;
    }
    if (this.activeTab === 'achievement') {
      this.loadAchievements();
    } else {
      this.loadEventSignups();
    }
  },
  mounted() {
    this.pcaData = new Area();
  },
  methods: {
    reviewStatusText(record) {
      const key = Number(record.reviewStatus);
      return record.reviewStatus_dictText || this.reviewStatusMap[key] || "待审核";
    },
    statusColor(status) {
      const map = { 1: "green", 2: "red", 0: "orange" };
      const key = Number(status);
      return map[key] || "orange";
    },
    loadAchievements(pagination) {
      if (pagination) {
        this.achievementPagination = Object.assign({}, this.achievementPagination, pagination);
      }
      const params = {
        pageNo: this.achievementPagination.current,
        pageSize: this.achievementPagination.pageSize
      };
      this.achievementLoading = true;
      getAction("/xjtech/techAchievement/myAchievement", params)
        .then((res) => {
          if (res.success) {
            this.achievementList = (res.result && res.result.records) || [];
            this.achievementPagination = Object.assign({}, this.achievementPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取成果列表失败");
          }
        })
        .finally(() => {
          this.achievementLoading = false;
        });
    },
    loadDemands(pagination) {
      if (pagination) {
        this.demandPagination = Object.assign({}, this.demandPagination, pagination);
      }
      const params = {
        pageNo: this.demandPagination.current,
        pageSize: this.demandPagination.pageSize
      };
      this.demandLoading = true;
      getAction("/xjtech/techRequirement/myRequirement", params)
        .then((res) => {
          if (res.success) {
            this.demandList = (res.result && res.result.records) || [];
            this.demandPagination = Object.assign({}, this.demandPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取需求列表失败");
          }
        })
        .finally(() => {
          this.demandLoading = false;
        });
    },
    handleTabChange(key) {
      this.activeTab = key;
      if (key === "achievement") {
        this.loadAchievements();
      } else if (key === "demand") {
        this.loadDemands();
      } else if (key === "eventSignup") {
        this.loadEventSignups();
      } else if (key === "follow") {
        // 根据当前关注类型加载对应数据
        if (this.followActiveType === "achievement") {
          this.loadFollowAchievements();
        } else if (this.followActiveType === "expert") {
          this.loadFollowExperts();
        }
      } else if (key === "cooperation") {
        this.loadCooperations();
      } else if (key === "bid") {
        this.loadBids();
      }
    },
    handleAchievementChange(pagination) {
      this.loadAchievements({ current: pagination.current, pageSize: pagination.pageSize });
    },
    handleDemandChange(pagination) {
      this.loadDemands({ current: pagination.current, pageSize: pagination.pageSize });
    },
    loadEventSignups(pagination) {
      if (pagination) {
        this.eventSignupPagination = Object.assign({}, this.eventSignupPagination, pagination);
      }
      const params = {
        pageNo: this.eventSignupPagination.current,
        pageSize: this.eventSignupPagination.pageSize
      };
      this.eventSignupLoading = true;
      getAction("/xjtech/eventSignup/myList", params)
        .then((res) => {
          if (res.success) {
            this.eventSignupList = (res.result && res.result.records) || [];
            this.eventSignupPagination = Object.assign({}, this.eventSignupPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取报名列表失败");
          }
        })
        .finally(() => {
          this.eventSignupLoading = false;
        });
    },
    handleEventSignupChange(pagination) {
      this.loadEventSignups({ current: pagination.current, pageSize: pagination.pageSize });
    },
    eventSignupStatusText(status) {
      const map = { 0: "待审核", 1: "已通过", 2: "已驳回", 3: "已取消", 4: "草稿" };
      return map[Number(status)] || "待审核";
    },
    eventSignupStatusColor(status) {
      const map = { 0: "orange", 1: "green", 2: "red", 3: "default", 4: "blue" };
      return map[Number(status)] || "orange";
    },
    canEditEventSignup(record) {
      const status = Number(record.auditStatus);
      if (status === 1 || status === 3) {
        return false;
      }
      if (!record.eventEndTime) {
        return true;
      }
      return new Date(record.eventEndTime).getTime() >= Date.now();
    },
    editEventSignup(record) {
      if (!this.canEditEventSignup(record)) {
        this.$message.warning("当前报名不可修改");
        return;
      }
      this.$router.push({ path: "/event/signup", query: { id: record.eventId } });
    },
    canDownloadApplication(record) {
      return Number(record.auditStatus) !== 4 && !!record.applicationTemplate;
    },
    canUploadApplication(record) {
      return Number(record.auditStatus) !== 4;
    },
    downloadApplicationWord(record) {
      if (!this.canDownloadApplication(record)) {
        this.$message.warning(record.applicationTemplate ? "草稿状态不能下载申请表" : "当前活动未配置申请表模板");
        return;
      }
      downloadFile("/xjtech/eventSignup/applicationWord", `${record.eventName || "活动"}申请表.docx`, { id: record.id });
    },
    openApplicationUpload(record) {
      if (!this.canUploadApplication(record)) {
        this.$message.warning("草稿状态不能上传申请表");
        return;
      }
      this.applicationSignup = record;
      this.applicationImages = record.applicationImages || "";
      this.applicationUploadVisible = true;
    },
    saveApplicationImages() {
      if (!this.applicationSignup) {
        this.closeApplicationUpload();
        return;
      }
      const payload = {
        id: this.applicationSignup.id,
        applicationImages: this.applicationImages
      };
      this.applicationUploading = true;
      httpAction("/xjtech/eventSignup/uploadApplicationImages", payload, "put")
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message || "上传成功");
            this.closeApplicationUpload();
            this.loadEventSignups();
          } else {
            this.$message.warning(res.message || "上传失败");
          }
        })
        .finally(() => {
          this.applicationUploading = false;
        });
    },
    closeApplicationUpload() {
      this.applicationUploadVisible = false;
      this.applicationSignup = null;
      this.applicationImages = "";
    },
    goEventDetail(record) {
      this.$router.push({ path: "/event/detail", query: { id: record.eventId } });
    },
    // 关注成果相关方法
    loadFollowAchievements(pagination) {
      if (pagination) {
        this.followAchievementPagination = Object.assign({}, this.followAchievementPagination, pagination);
      }
      const params = {
        pageNo: this.followAchievementPagination.current,
        pageSize: this.followAchievementPagination.pageSize,
        type: 0
      };
      this.followAchievementLoading = true;
      getAction("/xjtech/techInteraction/myFollow", params)
        .then((res) => {
          if (res.success) {
            this.followAchievementList = (res.result && res.result.records) || [];
            this.followAchievementPagination = Object.assign({}, this.followAchievementPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取关注成果列表失败");
          }
        })
        .finally(() => {
          this.followAchievementLoading = false;
        });
    },
    handleFollowAchievementChange(pagination) {
      this.loadFollowAchievements({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 合作列表相关方法
    loadCooperations(pagination) {
      if (pagination) {
        this.cooperationPagination = Object.assign({}, this.cooperationPagination, pagination);
      }
      const params = {
        pageNo: this.cooperationPagination.current,
        pageSize: this.cooperationPagination.pageSize,
        type: 1
      };
      this.cooperationLoading = true;
      getAction("/xjtech/techInteraction/myFollow", params)
        .then((res) => {
          if (res.success) {
            this.cooperationList = (res.result && res.result.records) || [];
            this.cooperationPagination = Object.assign({}, this.cooperationPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取合作列表失败");
          }
        })
        .finally(() => {
          this.cooperationLoading = false;
        });
    },
    handleCooperationChange(pagination) {
      this.loadCooperations({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 揭榜列表相关方法
    loadBids(pagination) {
      if (pagination) {
        this.bidPagination = Object.assign({}, this.bidPagination, pagination);
      }
      const params = {
        pageNo: this.bidPagination.current,
        pageSize: this.bidPagination.pageSize
      };
      this.bidLoading = true;
      getAction("/xjtech/techInteraction/myRequirementApply", params)
        .then((res) => {
          if (res.success) {
            this.bidList = (res.result && res.result.records) || [];
            this.bidPagination = Object.assign({}, this.bidPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取揭榜列表失败");
          }
        })
        .finally(() => {
          this.bidLoading = false;
        });
    },
    handleBidChange(pagination) {
      this.loadBids({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 关注专家相关方法
    loadFollowExperts(pagination) {
      if (pagination) {
        this.followExpertPagination = Object.assign({}, this.followExpertPagination, pagination);
      }
      this.followExpertLoading = true;
      // 使用假数据
      setTimeout(() => {
        this.followExpertList = [
          { id: 1, name: "张教授", unit: "清华大学", field: "人工智能", followTime: "2024-01-15 10:30:00" },
          { id: 2, name: "李博士", unit: "北京大学", field: "生物医药", followTime: "2024-01-10 14:20:00" }
        ];
        this.followExpertPagination = Object.assign({}, this.followExpertPagination, {
          total: 2
        });
        this.followExpertLoading = false;
      }, 300);
    },
    handleFollowExpertChange(pagination) {
      this.loadFollowExperts({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 关注类型切换方法
    handleFollowTypeChange(type) {
      this.followActiveType = type;
      if (type === "achievement") {
        this.loadFollowAchievements();
      } else if (type === "expert") {
        this.loadFollowExperts();
      }
    },
    getAreaText(code) {
      if (!code || !this.pcaData) {
        return ''
      }
      return this.pcaData.getText(code) || ''
    },
    // 取消关注方法
    cancelFollow(techId) {
      this.followAchievementLoading = true;
      getAction("/xjtech/techInteraction/cancelFollow", { techId,type: 0 })
        .then((res) => {
          if (res.success) {
            this.$message.success("取消关注成功");
            this.loadFollowAchievements(); // 重新加载关注成果列表
          } else {
            this.$message.warning(res.message || "取消关注失败");
          }
        })
        .finally(() => {
          this.followAchievementLoading = false;
        });
    },
    // 删除合作方法
    deleteCooperation(techId) {
      this.cooperationLoading = true;
      getAction("/xjtech/techInteraction/cancelFollow", { techId,type: 1 })
        .then((res) => {
          if (res.success) {
            this.$message.success("删除合作成功");
            this.loadCooperations(); // 重新加载合作列表
          } else {
            this.$message.warning(res.message || "删除合作失败");
          }
        })
        .finally(() => {
          this.cooperationLoading = false;
        });
    },
    // 加载合作请求列表方法
    loadCooperationRequests(pagination) {
      if (pagination) {
        this.cooperationRequestPagination = Object.assign({}, this.cooperationRequestPagination, pagination);
      }
      const params = {
        pageNo: this.cooperationRequestPagination.current,
        pageSize: this.cooperationRequestPagination.pageSize,
        techId: this.currentTechId,
        type: 1
      };
      this.cooperationListLoading = true;
      getAction("/xjtech/techInteraction//list", params)
        .then((res) => {
          if (res.success) {
            this.cooperationRequestList = (res.result && res.result.records) || [];
            this.cooperationRequestPagination = Object.assign({}, this.cooperationRequestPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取合作请求列表失败");
          }
        })
        .finally(() => {
          this.cooperationListLoading = false;
        });
    },
    // 打开合作请求模态框方法
    openCooperationModal(record) {
      this.currentTechId = record.id;
      this.cooperationModalVisible = true;
      this.cooperationRequestPagination.current = 1;
      this.loadCooperationRequests();
    },
    // 关闭合作请求模态框方法
    closeCooperationModal() {
      this.cooperationModalVisible = false;
      this.currentTechId = null;
    },
    // 处理合作请求列表分页变更方法
    handleCooperationRequestChange(pagination) {
      this.loadCooperationRequests({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 打开详情弹窗方法
    openDetailModal(record) {
      this.currentDetailData = record;
      this.detailModalVisible = true;
    },
    // 关闭详情弹窗方法
    closeDetailModal() {
      this.detailModalVisible = false;
      this.currentDetailData = null;
    },
    // 删除揭榜方法
    deleteBid(techId) {
      this.bidLoading = true;
      getAction("/xjtech/techInteraction/cancelFollow", { techId,type: 2 })
        .then((res) => {
          if (res.success) {
            this.$message.success("删除揭榜成功");
            this.loadBids(); // 重新加载揭榜列表
          } else {
            this.$message.warning(res.message || "删除揭榜失败");
          }
        })
        .finally(() => {
          this.bidLoading = false;
        });
    },
    goAchievementDetail(record) {
      this.$router.push({ path: "/achievement/detail", query: { id: record.id } });
    },
    goDemandDetail(record) {
      this.$router.push({ path: "/demand/detail", query: { id: record.id } });
    },
    editAchievement(record) {
      this.$router.push({ path: "/achievement/create", query: { id: record.id } });
    },
    editDemand(record) {
      this.$router.push({ path: "/demand/create", query: { id: record.id } });
    },
    removeAchievement(record) {
      deleteAction("/xjtech/techAchievement/delete", { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
          this.loadAchievements();
        } else {
          this.$message.warning(res.message || "删除失败");
        }
      });
    },
    removeDemand(record) {
      deleteAction("/xjtech/techRequirement/delete", { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
          this.loadDemands();
        } else {
          this.$message.warning(res.message || "删除失败");
        }
      });
    },
    // 打开揭榜列表模态框方法
    openBidListModal(record) {
      this.currentDemandId = record.id;
      this.bidListModalVisible = true;
      this.bidListPagination.current = 1;
      this.loadBidList();
    },
    // 关闭揭榜列表模态框方法
    closeBidListModal() {
      this.bidListModalVisible = false;
      this.currentDemandId = null;
    },
    // 加载揭榜列表方法
    loadBidList(pagination) {
      if (pagination) {
        this.bidListPagination = Object.assign({}, this.bidListPagination, pagination);
      }
      const params = {
        pageNo: this.bidListPagination.current,
        pageSize: this.bidListPagination.pageSize,
        techId: this.currentDemandId,
        type: 2
      };
      this.bidListLoading = true;
      getAction("/xjtech/techInteraction//list", params)
        .then((res) => {
          if (res.success) {
            this.bidListData = (res.result && res.result.records) || [];
            this.bidListPagination = Object.assign({}, this.bidListPagination, {
              total: (res.result && res.result.total) || 0
            });
          } else {
            this.$message.warning(res.message || "获取揭榜列表失败");
          }
        })
        .finally(() => {
          this.bidListLoading = false;
        });
    },
    // 处理揭榜列表分页变更方法
    handleBidListChange(pagination) {
      this.loadBidList({ current: pagination.current, pageSize: pagination.pageSize });
    },
    // 打开揭榜详情模态框方法
    openBidDetailModal(record) {
      this.currentBidDetailData = record;
      this.bidDetailModalVisible = true;
    },
    // 关闭揭榜详情模态框方法
    closeBidDetailModal() {
      this.bidDetailModalVisible = false;
      this.currentBidDetailData = null;
    }
  }
};
</script>

<style scoped lang="less">
.personal-center {
  max-width: 1200px;
  margin: 0 auto;
}

.header-card {
  margin-bottom: 16px;
}

.user-meta {
  display: flex;
  align-items: center;
  gap: 16px;

  .user-text {
    .name {
      font-size: 20px;
      font-weight: 600;
    }
    .desc {
      color: #888;
      margin-top: 4px;
    }
  }
}

.content-card {
  .ant-table {
    margin-top: 12px;
  }
}
.disabled {
  color: #bfbfbf;
  cursor: not-allowed;
}
</style>

